import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {AppVersion} from '../../modelinterfaces/app-version.model';
import {AppVersionService} from '../../services/app-version.service';
import {GUI_VERSION} from '../../app-env/gui-version';
import {TranslateModule} from "@ngx-translate/core";
import {MatDivider} from "@angular/material/divider";
import {AsyncPipe} from "@angular/common";
import {DialogComponent} from "@common-module/dialog/dialog/dialog.component";

@Component({
    selector: 'app-version',
  imports: [
    TranslateModule,
    MatDivider,
    AsyncPipe,
    DialogComponent
  ],
    templateUrl: './app-version.component.html',
    styleUrls: ['./app-version.component.scss', '../../app-styles/dialog-common.scss']
})

export class AppVersionComponent implements OnInit {

  public version$: Observable<AppVersion>;
  public readonly guiVersion = GUI_VERSION;

  constructor(private appVersionService: AppVersionService,
              private dialogRef: MatDialogRef<AppVersionComponent>) {
  }

  ngOnInit(): void {
    this.getData();
  }

  private getData(): void {
    this.version$ = this.appVersionService.get();
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
